module.exports = __webpack_public_path__ + "static/media/mercearia.2b773443.svg";